import http from 'plugins/axios';

export default {
  uploadPoster(data) {
    return http.post({
      url: '/la/admin/chat/jurisdiction/add',
      data,
      dataType: 'form'
    });
  },
  getList(data) {
    return http.get({
      url: '/la/admin/chat/jurisdiction/list',
      data
    });
  },
  removeList(data) {
    return http.post({
      url: '/la/admin/chat/jurisdiction/delete',
      data,
      dataType: 'form'
    });
  },
  getCoinTypeList() {
    return http.get({
      url: '/la/admin/coin/allDisplay'
    });
  }
};
